import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { authInterceptor } from '@lb/auth/interceptors/auth.interceptor';
import { impersonationInterceptor } from '@lb/auth/interceptors/impersonation.interceptor';
import { provideMDUI } from '@melodic-ui/configuration';
import { createAppRoutes } from './app.routes';
import { APP_BASE_HREF } from '@angular/common';
import { APP_CONFIG, IAppSettings } from '@lb/config/interfaces/iapp-settings.interface';
import { provideAnalyticsApp, provideAppInsights } from '@lb/services';
import { provideLearnerApplicationState } from './shared/state/learner-application.store';
import { provideMarkdown } from 'ngx-markdown';

export function createAppConfig(appSettings: IAppSettings): ApplicationConfig {
	return {
		providers: [
			{ provide: APP_CONFIG, useValue: appSettings },
			{
				provide: APP_BASE_HREF,
				useValue: appSettings.baseHref || '/'
			},
			provideZoneChangeDetection({ eventCoalescing: true }),
			provideRouter(createAppRoutes(appSettings)),
			provideHttpClient(withInterceptors([authInterceptor, impersonationInterceptor])),
			provideAnimationsAsync(),
			provideMDUI({ iconBaseUrl: './assets/icons' }),
			provideLearnerApplicationState(),
			provideMarkdown(),
			// Identifies this app to analytics. Read in AnalyticsService's constructor, so it also
			// decides whether Clarity runs here at all (analytics.clarity.excludeApps).
			provideAnalyticsApp('learner'),
			// Registers the App Insights ErrorHandler when a connection string is configured (staging);
			// contributes nothing otherwise, leaving the default Angular ErrorHandler in place.
			...provideAppInsights(appSettings)
		]
	};
}
